import './App.css';
import React, { createRef, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client'
import './global.scss';
import './sidebar.scss';
import axios from 'axios';
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  useOutlet,
  Navigate
} from 'react-router-dom'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { NotificationContainer } from 'react-notifications';


import { Footer } from './components/global/footer/Footer';
import { Topbar } from './components/global/top/Topbar';
import { Header } from './components/global/header/Header';

import Home from './pages/home/Home';
import About from './pages/about/About';
import { SingleAbout } from './pages/about/SingleAbout';
import { PracticeAreas } from './pages/practice-areas/PracticeAreas';
import { SinglePA } from './pages/practice-areas/SinglePA';
import Blog from './pages/blog';
import { SingleBlog } from './pages/blog/single';
import Resources from './pages/resources/Resources';
import { ContactUs } from './pages/contact-us/ContactUs';
import { NotFound } from './pages/404/404';
import Thankyou from './pages/thankyou/Thankyou';


axios.defaults.baseURL = 'https://www.alinealawpllc.com/';


const routes = [
  {path: '/', name: 'Home', element: <Home />, nodeRef: createRef()},  
  {path: '/home', name: 'Home', element: <Home />, nodeRef: createRef()},    
  {path: '/about', name: 'About', element: <About />, nodeRef: createRef()},      
  {path: '/about/:slug/', name: 'SingleAbout', element: <SingleAbout parent_slug={'about'}/>, nodeRef: createRef()},    
  {path: '/legal-blog', name: 'Blog', element: <Blog />, nodeRef: createRef()},    
  {path: '/blog', name: 'Blog', element: <Navigate to="/legal-blog" />, nodeRef: createRef()},
  {path: '/legal-blog/:slug/', name: 'Article', element: <SingleBlog />, nodeRef: createRef()},
  {path: '/contact-us/', name: 'ContactUs', element: <ContactUs />, nodeRef: createRef()},
  // {path: '/practice-areas/', name: 'PracticeAreas', element: <Home />, nodeRef: createRef()},
  {path: '/practice-areas', name: 'SinglePracticeArea', element: <Navigate to="/practice-areas/family-law" />, nodeRef: createRef()},
  {path: '/practice-areas/:slug/', name: 'SinglePracticeArea', element: <SinglePA parent_slug={'practice-areas'} />, nodeRef: createRef()},
  {path: '/resources/', name: 'Resources', element: <Resources />, nodeRef: createRef()},
  {path: '/not-found/', name: 'NotFound', element: <NotFound />, nodeRef: createRef()},
  {path: '/thank-you/', name: 'Thankyou', element: <Thankyou />, nodeRef: createRef()},
  
]


const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: routes.map((route) => ({
      index: route.path === '/',
      path: route.path === '/' ? undefined : route.path,
      element: route.element,
    })),
  },
]);


function App() {
  const location = useLocation()
  const currentOutlet = useOutlet()
  const [menus, setMenus] = useState(null);
  const [footerMenu, setFooterMenu] = useState([]);
  const [globalOptions, setGlobalOptions] = useState(null);


  useEffect(() => {
    window.scrollTo(0, 0);
    return (() => {})
  }, [location]);

  const fetchMenus = async () => {
    try {
      const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_menu_content");
      setMenus(data?.data?.header_menu ?? '');
      setFooterMenu(data?.data?.footer_menu ?? '');
    } catch (e) {
      setMenus('');
      setFooterMenu('');
    }
  };

  const fetchGlobalOptions = async () => {
    try {
      const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_global_site_options");
      setGlobalOptions(data);
    } catch (e) {
      setGlobalOptions(null);
    }
  }


  useEffect(() => {
    fetchMenus();
    fetchGlobalOptions();
  }, [])


  const { nodeRef } =
    routes.find((route) => route.path === location.pathname) ?? {}
  
  return (
    <>
      <div id="page-wrapper">
        <NotificationContainer />
        {/* <Topbar globalOptions={globalOptions} /> */}
        <Header menu={menus} globalOptions={globalOptions} />
        <div className='page-main-wrapper'>
          <SwitchTransition>            
            <CSSTransition
              key={location.pathname}
              nodeRef={nodeRef}
              timeout={300}
              classNames="page"
              unmountOnExit
            >

              {(state) => (
                <>
                  <div ref={nodeRef} className="page">
                    {currentOutlet}
                  </div>
                </>
              )}
            </CSSTransition>
          </SwitchTransition>
        </div>
            <Footer globalOptions={globalOptions} footerMenu={footerMenu} />
      </div>
    </>
  )
}
const container = document.getElementById('root')
const root = createRoot(container)
root.render(<RouterProvider router={router} />)
